<template>
  <div class="weather-exceptions-editor">
    <ExceptionCriteriaEditor
      :modelValue="criteria"
      :combineMode="combineMode"
      :businessHours="businessHours"
      :unitGroup="unitGroup"
      :showNotification="true"
      :notificationTrigger="notificationTrigger"
      :showCancel="false"
      :customPresets="customPresets"
      @update:modelValue="onCriteriaChange"
      @update:combineMode="onCombineModeChange"
      @update:businessHours="onBusinessHoursChange"
      @update:notificationTrigger="onNotificationTriggerChange"
      @save="onSave"
      @save-preset="onSavePreset"
    />
  </div>
</template>

<script>
import ExceptionCriteriaEditor from '../weatherexceptions/ExceptionCriteriaEditor.vue';

export default {
  name: 'WeatherExceptionsEditor',
  components: { ExceptionCriteriaEditor },

  props: {
    /** The parsed exception definition object */
    definition: {
      type: Object,
      default: () => ({})
    },
    /** Unit group for unit-aware preset values */
    unitGroup: {
      type: String,
      default: 'us'
    }
  },

  emits: ['update'],

  data() {
    return {
      customPresets: []
    };
  },

  computed: {
    criteria() {
      return this.definition?.criteria || [];
    },
    combineMode() {
      return this.definition?.combinationMethod?.toUpperCase() || 'OR';
    },
    businessHours() {
      const bh = this.definition?.businessHours;
      return bh ? { enabled: !!bh.enabled, start: bh.start || '08:00', end: bh.end || '17:00' } : { enabled: false, start: '08:00', end: '17:00' };
    },
    notificationTrigger() {
      return this.definition?.notificationTrigger || 'any_exception';
    }
  },

  mounted() {
    this.loadCustomPresets();
  },

  methods: {
    /** Build and emit the updated definition */
    emitUpdate(overrides = {}) {
      const defn = {
        criteria: this.criteria,
        combinationMethod: this.combineMode.toLowerCase(),
        businessHours: { ...this.businessHours },
        notificationTrigger: this.notificationTrigger,
        ...overrides
      };
      this.$emit('update', defn);
    },

    onCriteriaChange(criteria) {
      this.emitUpdate({ criteria });
    },

    onCombineModeChange(mode) {
      this.emitUpdate({ combinationMethod: mode.toLowerCase() });
    },

    onBusinessHoursChange(bh) {
      this.emitUpdate({ businessHours: bh });
    },

    onNotificationTriggerChange(trigger) {
      this.emitUpdate({ notificationTrigger: trigger });
    },

    onSave(payload) {
      // When Save Criteria is clicked, emit the full definition
      this.emitUpdate({
        criteria: payload.criteria,
        combinationMethod: payload.combineMode.toLowerCase(),
        businessHours: payload.businessHours,
        notificationTrigger: payload.notificationTrigger
      });
    },

    onSavePreset(preset) {
      const existingIdx = this.customPresets.findIndex(p => p.name === preset.name);
      if (existingIdx >= 0) {
        this.customPresets.splice(existingIdx, 1, preset);
      } else {
        this.customPresets.push(preset);
      }
      this.saveCustomPresets();
    },

    loadCustomPresets() {
      try {
        const saved = localStorage.getItem('weatherExceptions_customPresets');
        if (saved) this.customPresets = JSON.parse(saved);
      } catch (e) { /* ignore */ }
    },

    saveCustomPresets() {
      try {
        localStorage.setItem('weatherExceptions_customPresets', JSON.stringify(this.customPresets));
      } catch (e) { /* ignore */ }
    }
  }
};
</script>
